import {SearchResultThumbnailContainerService} from "../../../search/searchResult/searchResultThumbnail/searchResultThumbnailContainer.service";
import {Component, OnInit, Input, Inject} from 'ng-metadata/core';
import {FeaturedResultItemService} from './featuredResultItem.service';
import {isBoolean} from "ng-metadata/src/facade/lang";
import {STATE_NAMES} from "../../../primoExplore/primoExploreStates.module";
import {getVid, getInstitutionCode} from '../../../appConfig/appConfigForward';
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";
import {beacon, PrimolyticsService} from "../../../analytics/primolytics.service";

const get= require('lodash/get');

@Component({
    selector: 'prm-featured-result-item',
    templateUrl: 'components/search/searchResult/featuredResults/featured-result-item.html',
})

export class PrmFeaturedResultItem implements OnInit {
    @Input()  featuredResultItem;
    @Input() adaptor;
    @Input() tab;
    @Input() scope;
    @Input() format;
    @Input() index;

    constructor( 
        @Inject('$state') private $state: ng.ui.IStateService,
        @Inject('$location') private $location: ng.ILocationService,
        @Inject('$translate')  private $translate:ng.translate.ITranslateService,
        private searchResultThumbnailContainerService: SearchResultThumbnailContainerService,
        private configurationUtil: ConfigurationUtil, 
        private primolyticsService: PrimolyticsService) {
            this.featuredResultItem.thumbnailLinks =this.featuredResultItem.thumbnailLinks.map(val => { let link = {linkURL:val}; return link});  
            if('person' === this.featuredResultItem.itemType && !this.featuredResultItem.thumbnailLinks){
                this.getPersonPageThumbnailLinks();
            }
    }

    ngOnInit() {
    }

    private getPersonPageThumbnailLinks() {
        let itemThumbnailLink = get(this.featuredResultItem, 'item.delivery.link', []);
        let itemThumbnailRecordId = get(this.featuredResultItem, 'item.pnx.control.recordid[0]', '');
        this.searchResultThumbnailContainerService.getThumbnailLinks(itemThumbnailLink, true, undefined, undefined, this.featuredResultItem.item, undefined, undefined, itemThumbnailRecordId)
            .then((thumbnailLinkObject) => {
                this.featuredResultItem.thumbnailLinks = [get(thumbnailLinkObject, 'linkURL', '')]
                    .map(val => { let link = { linkURL: val }; return link; });
            });
    }

    get isThumbnails():boolean{
        if(this.format === "thumbnails"){
            return true;
        }
        return false;
    }


    get formatType() {
        if (this.featuredResultItem.type === 'image' ){
            return 'image';
        }
        else if(this.featuredResultItem.type === 'article'){
            return 'article';
        }
        else{
            return 'book';
        }
    }


    get picOfImageItem(){
        //if(this.featuredResultItem.thumbnailLinks[0] === 'no_cover'){
           // return 'https://books.google.com/books/content?id=AzhHnAIv_G0C&printsec=frontcover&img=1&zoom=5&edge=curl';
        //}
        return this.featuredResultItem.thumbnailLinks[0];
    }




    get showEllipsis():boolean{
        let num:number = !this.isThumbnails? 10 : 3;
        return this.featuredResultItem.title.split(" ").length > num;
    }
    get title() : string{
         /*
            NuiTitle is the display title
            title is the vertitle
            Since in the original title (CUI) - we had the vertitle || title and in the NUI title we have title || vertitle
            We want to display vertitle/title - and the code is complixated accordingly
         */
        let titleToDisplay = this.featuredResultItem.title ?  this.featuredResultItem.title  : '';
        titleToDisplay += (this.featuredResultItem.nuiTitle && this.featuredResultItem.nuiTitle !== this.featuredResultItem.title)  ?  '/' + this.featuredResultItem.nuiTitle : '';
        return titleToDisplay;
    }

    get displayLines():string{
        return this.getTextFromVal(this.featuredResultItem.generalData);
    }

    getTextFromVal(value) {
        if (value.includes('$$Q')) {
			let text = value.split('$$Q')[0];//text
			if (text.includes('$$C')) {
				text = this.getSubfieldFromVal(text, '$$V');
			}
			return text;
		} else if (value.includes('$$Z')) {
			let text = value.split('$$Z')[0];//text
			if (text.includes('$$C')) {
				text = this.getSubfieldFromVal(text, '$$V');
			}
			return text;
		} else if (value.includes('$$V')) {
			return this.getSubfieldFromVal(value, '$$V');
		} else {
			return value;
		}
    }

    private getFullDisplayStateParams(){
        return{
            docid:this.featuredResultItem.recordId,
            vid: getVid(),
            context: this.configurationUtil.isSuprima()?this.featuredResultItem.context:this.scope,
            search_scope: this.scope,
            adaptor:this.adaptor,
            tab: this.tab,
            query:this.$state.params['query'],
            sortby: this.$state.params['sortby'],
            offset:"0", //because this is always the first page.
            lang:this.$state.params['lang'],
            fromFeaturedResult:true,
            originScope : this.$state.params['search_scope'],
            originTab : this.$state.params['tab'],
            prevPersonId: this.$state.current.name === STATE_NAMES.PERSON_ENTITY_PAGE ? this.$location.search()["personId"] : undefined,
            fromJournalSearch: undefined
        }
    }


    public fullDisplayParam(){              
        if('relatedPerson' === get(this,'featuredResultItem.itemType','')){
            return this.navigateToPersonPage();
        }
        return this.$state.href(STATE_NAMES.FULL_DISPLAY, this.getFullDisplayStateParams(), {lossy:true});
    }

    public navigateToPersonPage() {
        let personEntityPagesParams = {
            prevPersonId:  this.$location.search()["personId"],
            personId: get(this,'featuredResultItem.personId',''),
            vid: getVid(), 
            inst: getInstitutionCode(),
            fromJournalSearch: undefined,
            lang: this.$translate.use()
        }
        return this.$state.href(STATE_NAMES.PERSON_ENTITY_PAGE, personEntityPagesParams, {lossy:true});
    }


    public getImage() {
          return this.featuredResultItem.thumbnailLinks || [];
    }



    get recordId():string{
        return this.featuredResultItem.recordId;
    }

    public sendFeaturedResultsItemBeacon(recordId){
        if (this.$state.current.name === STATE_NAMES.PERSON_ENTITY_PAGE){
            this.sendRelatedPersonItemBeacon(recordId);
            return;
        }
        this.sendFeaturedResultsItemBeaconAnnotation(recordId);
    }

    @beacon({'p':'featuredResults', 'op':'recordFeaturedResults'})
    public sendFeaturedResultsItemBeaconAnnotation(recordId){}

    @beacon({'p':'relatedPerson', 'op':'recordRelatedPersonTitles'})
    public sendRelatedPersonItemBeacon(recordId){}

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/featuredResults/featuredResultItem.directive.ts